import { yupResolver } from '@hookform/resolvers/yup';
import { notify } from "@/shared/utils/notify";
import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { validateCreateUsers, validateUpdateUsers } from '../../../helpers';
import { createUser, updateUser,selectIsUpdateUser, selectUserForUpdate, setIsUserForUpdate, userChangeModalState, userSetModalOpen, selectUserRefreshTable, refreshTableUsers } from '../../../redux';
import { IUserResFind } from '../../../redux/@types';
import useAppDispatch from '../../../redux/hooks/useAppDispatch';
import { useSelector } from 'react-redux';
import { TableProperties } from '../../../shared/components/ui/Table/types';
import { parseAllowedModules } from '../../../shared/utils/filterAdminMenu';

export const useUsers = () => {
  const dispatch = useAppDispatch();
  const isUpdateUser = useSelector(selectIsUpdateUser);
  const dataUpdateUser = useSelector(selectUserForUpdate);
  const isRefreshTableUsers = useSelector(selectUserRefreshTable)
  const [isLoading, setIsLoading] = useState(false);
  const [tableProps, setTableProps] = useState<TableProperties>();

  const changeModalUserState = () => {
    dispatch(setIsUserForUpdate(false))
    dispatch(userChangeModalState())
  }
  const formMethodsCreate = useForm<IUserResFind>({
    resolver: yupResolver(validateCreateUsers),
  })

  const formMethodsUpdate  = useForm<IUserResFind>({
    resolver: yupResolver(validateUpdateUsers),
  })

  /** Abre el modal de creación con valores iniciales (p. ej. rol domiciliario). */
  const openCreateUserModal = (defaults?: Partial<IUserResFind>) => {
    dispatch(setIsUserForUpdate(false));
    formMethodsCreate.reset({
      first_name: "",
      last_name: "",
      email: "",
      dni: "",
      phone: "",
      password: "",
      role: "user",
      status: "active",
      store_id: undefined,
      ...defaults,
    } as IUserResFind);
    dispatch(userSetModalOpen(true));
  };

  const normalizeAllowedModules = (
    data: IUserResFind,
    role: string
  ): string[] | null => {
    if (role !== "admin" && role !== "seller") return null;
    const mods = data.allowed_modules;
    if (!Array.isArray(mods) || mods.length === 0) return null;
    return mods.filter((k) => typeof k === "string");
  };

  const normalizeStoreId = (data: IUserResFind): number | null => {
    if (data.role !== "domiciliary") return null;
    if (data.store_id == null || String(data.store_id).trim() === "")
      return null;
    const n = Number(data.store_id);
    return Number.isFinite(n) ? n : null;
  };

  useEffect(() => {
    if (isUpdateUser) {
        formMethodsCreate.reset()
        formMethodsUpdate.reset({
          ...dataUpdateUser,
          allowed_modules:
            parseAllowedModules(dataUpdateUser?.allowed_modules) ?? [],
        })
    }

    return () => {
        formMethodsUpdate.reset()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
}, [isUpdateUser, dataUpdateUser])

  const onSubmitCreateOrUpdate = async(data: IUserResFind) => {
    if (isLoading) return;
    setIsLoading(true);
    if(isUpdateUser){
      const patch: Partial<IUserResFind> = {
        id: data.id,
        email: data.email,
        first_name: data.first_name,
        last_name: data.last_name,
        dni: data.dni,
        role: data.role,
        phone: data.phone,
        status: data.status,
        store_id: normalizeStoreId(data),
        allowed_modules: normalizeAllowedModules(data, data.role),
      };
      if (data.password?.trim()) {
        patch.password = data.password;
      }
      await updateUser(patch)
      .then((res:Partial<IUserResFind>)=>{
        setIsLoading(false)
        // dispatch(mappingUpdatedUser(res))
        if(res.id){
          notify.success(`Se ha actualizado con éxito el usuario con id:${res.id}`)
          dispatch(refreshTableUsers(true))
          dispatch(userChangeModalState())
        }
        else{
          notify.error(res as string)
        }
      })
    }else{
      const body: Partial<IUserResFind> = {
        ...data,
        store_id: normalizeStoreId(data),
        allowed_modules: normalizeAllowedModules(data, data.role),
      };
      await createUser(body)
      .then((res: IUserResFind)=>{
        setIsLoading(false)
        // dispatch(pushCreateUser(res))
        if(res.id){
          notify.success(`Se ha creado con éxito el usuario con id:${res.id}`)
          dispatch(refreshTableUsers(true))
          dispatch(userChangeModalState())
        }
        else{
          notify.error(res as any)
        }
      })
      .catch((err: any) =>{
        setIsLoading(false)
        console.log(err)
        notify.error(err.message)
      })
    }
  }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (isRefreshTableUsers) {
      tableProps?.refresh()
      dispatch(refreshTableUsers(false))
    }
  }, [isRefreshTableUsers])


  return {
    //state
    isUpdateUser,
    isLoading,
    tableProps,
    //methods
    formMethodsCreate,
    formMethodsUpdate,
    setTableProps,
    //functions
    onSubmitCreateOrUpdate,
    changeModalUserState,
    openCreateUserModal,
  }
}
